import React from 'react';
import Script from 'next/script';
export const PinterestScript = () => <Script type="text/javascript" strategy="lazyOnload" src="//assets.pinterest.com/js/pinit.js" data-sentry-element="Script" data-sentry-component="PinterestScript" data-sentry-source-file="index.tsx" />;